import { render, staticRenderFns } from "./FormTratta.vue?vue&type=template&id=0de405f9&"
import script from "./FormTratta.vue?vue&type=script&lang=js&"
export * from "./FormTratta.vue?vue&type=script&lang=js&"
import style0 from "./FormTratta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/FormTratta.vue
// module id = 758
// module chunks = 0